import { BaseModelPagedArray } from "@eview/core/base/base-model";
import { Post } from "@eview/core/domain/post/post";

export interface PostsState {
  posts: BaseModelPagedArray<Post>;
}

export const initialPostsState: PostsState = {
  posts: null
};
